<template>
	<VInputMask
		ref="company-bin-input"
		:value="company.additionalAttributes.bin.value"
		:label="company.additionalAttributes.bin.name"
		layout="vertical"
		:tokens="{
        '#': { pattern: /\d/ },
      }"
		mask="############"
		masked
		required
		:disabled="readOnly"
	/>
</template>

<script>

import KzUtils from "@/core/utils/regional/KzUtils";
import Company from "@/domains/Companies/Company.js";

export default {
	name:   'KZAdditionalAttributes',

	props: {
    company: {
      type:     Company,
      required: true
    },
		readOnly: {
			type: Boolean,
			default: false,
		}
	},

	data() {
		return {
			KzUtils,
		}
	}
};
</script>
